const BAM_SERVICE_NAME = 'lp-ccui-manager-workspace';

const BAM_EVENT_NAME_TYPES = {
  FILTER: 'filter',
  SORT: 'sort',
  TOGGLE_DISPLAY: 'toggle_display',
  RESIZE: 'resize',
  PAGINATION: 'pagination',
  ERROR_HANDLING: 'error_handling',
  SELECT: 'select',
  OPEN: 'open',
  HIDE: 'hide',
  TRANSCRIPT_NEW_MESSAGES: 'x_new_messages_shown',
  TRANSCRIPT_NEW_MESSAGES_POPUP: 'scroll_to_last_message',
  TRANSCRIPT_LOAD_CONVERSATION: 'load_transcript',
  VIEW_IN_AGENT_WORKSPACE: 'view_in_agent_ws',
  FOCUS: 'focus',
  SAVE_PRESET: 'save_preset',
  SELECT_PRESET: 'select_preset',
  OVERWRITE_PRESET: 'overwrite_preset',
  DELETE_PRESET: 'delete_preset',
  DISPLAY_ALERT: 'display_alert',
  SAVE_ALERT: 'save_alert',
  RESET_ALERT: 'reset_alert',
  VALIDATION_FAIL_ALERT: 'validation_fail_alert',
  CLEAR_FIELDS: 'clear_fields',
  THRESHOLD_REACHED: 'threshold_reached',
  SYSTEM: 'system',
  COLLAPSE: 'collapse',
  EXPAND: 'expand',
};

const BAM_TRIGGER_SOURCE = {
  WIDGET_HEADER: 'widget_header',
  TABLE_ROW: 'table_row',
  TABLE_HEADER: 'table_header',
  TABLE_BORDER: 'table_border',
  TRANSCRIPT_HEADER: 'transcript_header',
  TRANSCRIPT_FOOTER: 'transcript_footer',
  TRANSCRIPT_NEW_MESSAGES_POPUP: 'transcript_new_messages_popup',
  TRANSCRIPT_SWITCH: 'transcript_switch',
  TRANSCRIPT_ERROR: 'transcript_error_message',
  CARD: 'card',
  HORIZONTAL_RESIZE_HANDLE: 'horizontalResizeHandle',
  GLOBAL_FILTER_PANE: 'global_filter_pane',
  ALERT_CONFIG_ICON: 'alert_icon_config',
  ALERT_WARNING_ICON: 'alert_warning_icon',
  ALERT_DIALOG: 'alert_dialog',
  GLOBAL_MENU_PANE: 'global_menu_pane',
  METRIC_CONFIGURATION_TOGGLE: 'metric_configuration_toggle',
};

const BAM_PAGING = {
  FORWARDS: 'paging_forwards',
  BACKWARDS: 'paging_backwards',
};

export {
  BAM_SERVICE_NAME,
  BAM_EVENT_NAME_TYPES,
  BAM_TRIGGER_SOURCE,
  BAM_PAGING,
};
